import { useEffect, useState } from "react";
import api from "../../services/api";

/* ICONS */

import editIcon from "../../assets/edit-icon.png";
import deleteIcon from "../../assets/delete-icon.png";

/* COLORS */

const COLORS = {
  primary:"#0D47A1",
  danger:"#D32F2F",
  bg:"#FFF6EA",
  card:"#FFFFFF",
  border:"#E0E0E0",
  muted:"#757575"
};

const Expense = ()=>{

const [list,setList]=useState([]);
const [editingId,setEditingId]=useState(null);

const [form,setForm]=useState({
category:"",
description:"",
amount:"",
expense_date:new Date().toISOString().slice(0,10)
});

/* LOAD */

const load = async ()=>{

const res = await api.get("/expense/list.php");
setList(res.data?.data || []);

};

useEffect(()=>{
load();
},[]);

/* SUBMIT */

const submit = async (e)=>{

e.preventDefault();

if(!form.category || !form.amount){
alert("Category and amount required");
return;
}

if(editingId){

await api.post("/expense/update.php",{
id:editingId,
...form
});

}else{

await api.post("/expense/create.php",form);

}

setForm({
category:"",
description:"",
amount:"",
expense_date:new Date().toISOString().slice(0,10)
});

setEditingId(null);

load();

};

/* EDIT */

const editRow = (row)=>{

setForm({
category:row.category,
description:row.description,
amount:row.amount,
expense_date:row.expense_date
});

setEditingId(row.id);

};

/* DELETE */

const deleteRow = async (id)=>{

if(!window.confirm("Delete this expense?")) return;

await api.post("/expense/delete.php",{id});

load();

};

return(

<div style={styles.page}>

<div style={styles.header}>
<h2 style={styles.title}>Expenses</h2>
<div style={styles.subtitle}>
Record business expenses
</div>
</div>

{/* FORM */}

<div style={styles.card}>

<form onSubmit={submit}>

<input
placeholder="Category"
value={form.category}
onChange={(e)=>setForm({...form,category:e.target.value})}
style={styles.input}
/>

<input
placeholder="Description"
value={form.description}
onChange={(e)=>setForm({...form,description:e.target.value})}
style={styles.input}
/>

<input
type="number"
placeholder="Amount"
value={form.amount}
onChange={(e)=>setForm({...form,amount:e.target.value})}
style={styles.input}
/>

<input
type="date"
value={form.expense_date}
onChange={(e)=>setForm({...form,expense_date:e.target.value})}
style={styles.input}
/>

<button style={styles.btn}>
{editingId ? "Update Expense" : "Save Expense"}
</button>

</form>

</div>

{/* TABLE */}

<div style={{...styles.card,marginTop:20}}>

<div style={styles.tableWrap}>

<table style={styles.table}>

<thead>
<tr>
<th style={styles.th}>Date</th>
<th style={styles.th}>Category</th>
<th style={styles.th}>Description</th>
<th style={styles.th}>Amount</th>
<th style={styles.th}>Action</th>
</tr>
</thead>

<tbody>

{list.length === 0 && (
<tr>
<td colSpan="5" style={styles.td}>
No expenses recorded
</td>
</tr>
)}

{list.map((e)=>(
<tr key={e.id}>

<td style={styles.td}>{e.expense_date}</td>

<td style={styles.td}>{e.category}</td>

<td style={styles.td}>{e.description}</td>

<td style={{...styles.td,color:COLORS.danger}}>
₹ {Number(e.amount).toFixed(2)}
</td>

<td style={styles.td}>

<div style={styles.actions}>

<img
src={editIcon}
alt="edit"
style={styles.icon}
onClick={()=>editRow(e)}
/>

<img
src={deleteIcon}
alt="delete"
style={styles.icon}
onClick={()=>deleteRow(e.id)}
/>

</div>

</td>

</tr>
))}

</tbody>

</table>

</div>

</div>

</div>

);

};

/* RESPONSIVE STYLES */

const styles={

page:{
background:COLORS.bg,
padding:"20px clamp(15px,4vw,30px)",
minHeight:"100vh"
},

header:{
marginBottom:20,
display:"flex",
flexDirection:"column",
gap:4
},

title:{
fontSize:26,
fontWeight:700
},

subtitle:{
color:COLORS.muted
},

card:{
background:COLORS.card,
padding:20,
borderRadius:12,
border:`1px solid ${COLORS.border}`
},

input:{
width:"100%",
padding:10,
borderRadius:6,
border:`1px solid ${COLORS.border}`,
marginBottom:12,
boxSizing:"border-box"
},

btn:{
background:COLORS.primary,
color:"#fff",
padding:"10px 16px",
border:"none",
borderRadius:6,
cursor:"pointer",
width:"100%"
},

tableWrap:{
overflowX:"auto"
},

table:{
width:"100%",
borderCollapse:"collapse",
minWidth:650
},

th:{
textAlign:"left",
padding:12,
borderBottom:`1px solid ${COLORS.border}`
},

td:{
padding:12,
borderBottom:`1px solid ${COLORS.border}`
},

actions:{
display:"flex",
gap:10,
alignItems:"center"
},

icon:{
width:18,
cursor:"pointer"
}

};

export default Expense;